// Damage-tag presets used by the digital damage sheet. Keep this list in
// sync with the backend (PRESET_TAG_CODES in vehicle_damages/schemas.py).
//
// Each entry has a stable `code` (DB value), a human label, a short marker
// abbreviation for the diagram (1-2 chars), and a Tailwind color for the
// severity-agnostic chip in lists.

export const DAMAGE_TAGS = [
  { code: "small_scratch",   label: "Small scratch",     short: "S1", tone: "amber" },
  { code: "big_scratch",     label: "Big scratch",       short: "S2", tone: "amber" },
  { code: "small_dent",      label: "Small dent",        short: "D1", tone: "orange" },
  { code: "big_dent",        label: "Big dent",          short: "D2", tone: "orange" },
  { code: "paint_chip",      label: "Paint chip",        short: "P",  tone: "yellow" },
  { code: "cracked_glass",   label: "Cracked / chipped glass", short: "G", tone: "rose" },
  { code: "broken_light",    label: "Broken / cracked light",  short: "L", tone: "rose" },
  { code: "missing_trim",    label: "Missing trim / badge",    short: "T", tone: "slate" },
  { code: "tire_damage",     label: "Tire damage",       short: "Ti", tone: "slate" },
  { code: "wheel_damage",    label: "Wheel / rim damage", short: "W", tone: "slate" },
  { code: "interior_stain",  label: "Interior stain",    short: "Is", tone: "violet" },
  { code: "interior_tear",   label: "Interior tear",     short: "It", tone: "violet" },
  { code: "mechanical_issue", label: "Mechanical issue", short: "M", tone: "red" },
  { code: "other",           label: "Other (custom)",    short: "?", tone: "slate" },
];

export const tagByCode = (code) =>
  DAMAGE_TAGS.find((t) => t.code === code) || DAMAGE_TAGS[DAMAGE_TAGS.length - 1];

export const SEVERITY_OPTIONS = [
  { value: "small",  label: "Small",  ring: "ring-amber-400  bg-amber-500" },
  { value: "medium", label: "Medium", ring: "ring-orange-400 bg-orange-500" },
  { value: "big",    label: "Big",    ring: "ring-rose-500   bg-rose-600" },
];

export const VIEW_OPTIONS = [
  { value: "front",    label: "Front" },
  { value: "back",     label: "Back" },
  { value: "left",     label: "Left side" },
  { value: "right",    label: "Right side" },
  { value: "top",      label: "Top view" },
  { value: "interior", label: "Interior" },
];

export const CAR_VIEW_OPTIONS = VIEW_OPTIONS;

export const MOTORBIKE_VIEW_OPTIONS = [
  { value: "front", label: "Front" },
  { value: "back",  label: "Back" },
  { value: "left",  label: "Left side" },
  { value: "right", label: "Right side" },
  { value: "top",   label: "Top view" },
];

// Categories that should default to the motorbike diagram.
const MOTORBIKE_CATEGORY_KEYWORDS = [
  "motor", "motorcycle", "motorbike", "scooter", "moped", "bike",
];

export function detectVehicleType(category) {
  const c = String(category || "").toLowerCase();
  if (MOTORBIKE_CATEGORY_KEYWORDS.some((k) => c.includes(k))) return "motorbike";
  return "car";
}

export function defaultViewsForType(vehicleType) {
  return vehicleType === "motorbike" ? MOTORBIKE_VIEW_OPTIONS : CAR_VIEW_OPTIONS;
}


export const SEVERITY_DOT_CLASS = {
  small:  "bg-amber-500",
  medium: "bg-orange-500",
  big:    "bg-rose-600",
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
